import React from "react";
import { Flex } from "@chakra-ui/react";

/**
 * ModuleMark — the navy gradient square holding a short module code (e.g. "AP").
 * Template ref: `.moduleMark` (42px square, navy gradient, 14px radius, soft shadow).
 *
 * Props:
 *   code  - short label rendered inside (1-2 chars, e.g. "AP", "PI")
 *   size  - square dimension (default "42px")
 */
const ModuleMark = ({ code, size = "42px", fontSize = "16px", ...rest }) => (
  <Flex
    data-testid="module-mark"
    align="center"
    justify="center"
    w={size}
    h={size}
    flexShrink={0}
    color="white"
    fontWeight="800"
    fontSize={fontSize}
    letterSpacing="-0.01em"
    borderRadius="mark"
    boxShadow="mark"
    bgGradient="linear(135deg, #0B1F3A 0%, #1E4D78 100%)"
    {...rest}
  >
    {code}
  </Flex>
);

export default ModuleMark;
